import type { StateCreator } from 'zustand';
import type { AppState } from '../types';
import { DISCOVERY_STEPS } from '@/components/features/discovery/steps';

export interface DiscoverySlice {
    discovery: {
        active: boolean;
        persona: 'normal' | 'tech';
        discoveredSteps: string[];
        rewardType: 'sync' | 'print' | null;
        currentStepIdx: number;
    };
    setDiscoveryActive: (active: boolean) => void;
    setDiscoveryPersona: (persona: 'normal' | 'tech') => void;
    setDiscoveryStep: (idx: number) => void;
    jumpToStep: (stepId: string) => void;
    markStepDiscovered: (stepId: string) => void;
    resetDiscoveryProgress: () => void;
    setRewardType: (rewardType: 'sync' | 'print' | null) => void;
}

export const createDiscoverySlice: StateCreator<AppState, [], [], DiscoverySlice> = (set) => ({
    discovery: {
        active: false,
        persona: 'normal',
        discoveredSteps: [],
        rewardType: null,
        currentStepIdx: 0,
    },
    setDiscoveryActive: (active) => set((state) => ({
        discovery: { ...state.discovery, active }
    })),
    setDiscoveryPersona: (persona) => set((state) => {
        if (state.discovery.persona === persona) return state;
        return {
            discovery: {
                ...state.discovery,
                persona,
                discoveredSteps: [] // Reset so they see tips in new persona
            }
        };
    }),
    setDiscoveryStep: (currentStepIdx) => set((state) => ({
        discovery: { ...state.discovery, currentStepIdx }
    })),
    jumpToStep: (stepId) => set((state) => {
        const idx = DISCOVERY_STEPS.findIndex(s => s.id === stepId);
        if (idx === -1) return state;
        return {
            discovery: {
                ...state.discovery,
                currentStepIdx: idx,
                active: true
            }
        };
    }),
    markStepDiscovered: (stepId) => set((state) => {
        if (state.discovery.discoveredSteps.includes(stepId)) return state;
        return {
            discovery: {
                ...state.discovery,
                discoveredSteps: [...state.discovery.discoveredSteps, stepId]
            }
        };
    }),
    resetDiscoveryProgress: () => set((state) => ({
        discovery: {
            ...state.discovery,
            discoveredSteps: []
        }
    })),
    setRewardType: (rewardType) => set((state) => ({
        discovery: { ...state.discovery, rewardType }
    })),
});
